import request, {retryRequest} from "./request";
import {
    AppConfigType,
    BindInfoType,
    BindItemType,
    BindWalletParam,
    MetaPageType,
    OverviewInfo,
    PohItemType,
    PohZkpassParams,
    UserAssetToken,
    UserChainType,
    UserImportTokenType,
    UserTransactionNextPageParams,
    UserTransactionType,
    WalletAssetType,
    WalletChainType, WalletNFTType
} from "../types/types";

export const getEmailCodeApi = (email: string) => {
    return request<any>({
        url: `/api/v1/email/code`,
        method: "POST",
        data: {email}
    });
}

export const verifyEmailCodeApi = ({email, verification_key, verification_code}: {
    email: string,
    verification_key: string,
    verification_code: string
}) => {
    return request<any>({
        url: `/api/v1/user/email/login`,
        method: "POST",
        data: {email, verification_key, verification_code}
    });
}


export const getOverviewInfoApi = () => {
    return retryRequest<OverviewInfo>({
        url: `/api/v1/user/overview`,
        method: "GET",
    });
}
export const toLogoutApi = () => {
    return retryRequest<any>({
        url: `/api/v1/user/logout`,
        method: "POST",
    });
}

export const setUserNameApi = (data: any) => {
    return request({
        url: `/api/v1/user/name`,
        method: "POSt",
        data
    });
}

export const getBindListApi = () => {
    return retryRequest<BindItemType[]>({
        url: `/api/v1/bind/list`,
        method: "GET",
    });
}

export const getPohListApi = () => {
    return retryRequest<PohItemType[]>({
        url: `/api/v1/poh/list`,
        method: "GET",
    });
}

export const getBindInfoApi = () => {
    return retryRequest<BindInfoType>({
        url: `/api/v1/bind`,
        method: "GET",
    });
}


export const bindCexApi = (data: {
    cex: string,
    api_key: string,
    api_secret: string,
    api_passphrase?: string
}) => {
    return request<any>({
        url: `/api/v1/cex/subscribe`,
        method: "POST",
        data
    });
}


export const unBindApi = ({type}: { type: string }) => {
    return request<any>({
        url: `/api/v1/unbind`,
        method: "POST",
        data: {type}
    });
}

export const unBindWalletApi = ({address}: { address: string }) => {
    return request<any>({
        url: `/api/v1/wallet/unbind`,
        method: "POST",
        data: {address}
    });
}

export const verifyPohApi = ({
                                 taskId,
                                 schemaId,
                                 publicFields,
                                 allocatorAddress,
                                 publicFieldsHash,
                                 allocatorSignature,
                                 uHash,
                                 validatorAddress,
                                 validatorSignature
                             }: PohZkpassParams) => {
    return request<any>({
        url: `/api/v1/poh/zkpass`,
        method: "POST",
        data: {
            taskId,
            schemaId,
            publicFields,
            allocatorAddress,
            publicFieldsHash,
            allocatorSignature,
            uHash,
            validatorAddress,
            validatorSignature
        }
    });
}

export const chooseIdentityApi = ({identity}: { identity: string }) => {
    return request<any>({
        url: `/api/v1/user/choose/identity`,
        method: "POST",
        data: {identity}
    });
}

export const mintPassportNftApi = () => {
    return request<any>({
        url: `/api/v1/mint/passport/nft`,
        method: "POST",
    });
}

export const getAuthInfoApi = () => {
    return retryRequest<any>({
        url: `/api/v1/user/auth`,
        method: "GET",
    });
}

export const getWalletNonceApi = (data: { address: string, type: string }) => {
    return retryRequest<any>({
        url: `/api/v1/login/wallet/init`,
        method: "POST",
        data: data
    });
}

export const loginByWalletApi = ({
                                     type,
                                     address,
                                     signature,
                                     message,
                                     connector_type,
                                     wallet_client_type
                                 }: BindWalletParam) => {
    return request<any>({
        url: `/api/v1/login/wallet`,
        method: "POST",
        data: {type, address, signature, message, connector_type, wallet_client_type}
    });
}


export const getWalletInitApi = (data: { address: string, type: string }) => {
    return retryRequest<any>({
        url: `/api/v1/wallet/init`,
        method: "POST",
        data,
    });
}

export const toBindWalletApi = ({
                                    type,
                                    address,
                                    signature,
                                    message,
                                    connector_type,
                                    wallet_client_type
                                }: BindWalletParam) => {
    return request<any>({
        url: `/api/v1/wallet/bind`,
        method: "POST",
        data: {type, address, signature, message, connector_type, wallet_client_type}
    });
}

export const getAppConfigApi = () => {
    return retryRequest<AppConfigType>({
        url: `/api/v1/app/config`,
        method: "GET",
    });
}

export const getUserChainListApi = () => {
    return request<UserChainType[]>({
        url: `/api/v1/user/chain/list`,
        method: "GET",
    });
}

export const userImportTokenApi = (data: {
    chain_id: string,
    symbol: string,
    address: string,
    decimals: string,
}) => {
    return request<any>({
        url: `/api/v1/user/import/token`,
        method: "POST",
        data
    });
}
export const getUserImportTokenListApi = (data: {
    chain_id: string
}) => {
    return request<UserImportTokenType[]>({
        url: `/api/v1/user/import/token/list`,
        method: "POST",
        data
    });
}

export const getUserWalletAssetApi = (data: {
    chain_id: string
}) => {
    return request<UserAssetToken[]>({
        url: `/api/v1/user/wallet/asset`,
        method: "POST",
        data
    });
}

export const getUserWalletTransactionsApi = (data: {
    address?: string
    chain_id: string
    page?: string
    block_number?:number
    index?:number
    items_count?:number
}) => {
    return request<{
        transactions: UserTransactionType[]
        next_page_params:UserTransactionNextPageParams
    }>({
        url: `/api/v1/user/wallet/transactions`,
        method: "POST",
        data
    });
}

export const getWalletAssetListApi = (data: {
    chain_id: string
    address: string
}) => {
    return request<{
        asset_list:WalletAssetType[]
        asset_total_balance:string
    }>({
        url: `/api/v1/wallet/asset`,
        method: "POST",
        data
    });
}

export const getWalletListApi = (data: {
    page: number
    page_size: number
}) => {
    return request<MetaPageType<{
        wallet_list:{
            address:string
            chain_network:string
        }[]
        mpc_address:string
    }>>({
        url: `/api/v1/wallet/list`,
        method: "POST",
        data
    });
}

export const getWalletChainListApi = () => {
    return request<WalletChainType[]>({
        url: `/api/v1/wallet/chain`,
        method: "POST",
    });
}

export const getWalletNftListApi = (data:{
    chain_id:string
    address:string
})=>{
    return request<WalletNFTType[]>({
        url: `/api/v1/wallet/nfts`,
        method: "POST",
        data
    });
}

export const tgAppLoginInitApi = ()=>{
    return retryRequest<{
        code:string
        login_url:string
    }>({
        url: `/api/v1/tgapp/login/init`,
        method: "GET",
    });
}

export const getTgAppLoginStatus = (data:{
    code:string
})=>{
    return retryRequest<{
        access_token:string
        token_type:string
    }>({
        url: `/api/v1/tgapp/login/status`,
        method: "POST",
        data
    });
}

export const userInviteApi = (data:{
    invite_code:string
})=>{
    return request<any>({
        url: `/api/v1/user/invite`,
        method: "POST",
        data
    });
}
